import classNames from 'classnames'
import { FormikProps } from 'formik'
import { CreateProductValues } from '../../redux-toolkits/products/products.type'
import Icon from '../icon'
import Dropdown from '../inputs/dropdown'
import { TextInput } from '../inputs/textInput'
import { HeaderSubheader } from '../typography/HeaderSubheader'

const productWeightOptions = [
  {
    name: 'Grams',
    value: 'grams',
  },
  {
    name: 'Kilograms',
    value: 'kilograms',
  },
  {
    name: 'Pounds',
    value: 'pounds',
  },
]

export const ManageProductWeight = ({
  formik,
  className,
  typeTitle,
}: {
  formik: FormikProps<CreateProductValues>
  className?: string
  typeTitle: string
}) => {
  const { values, errors, setFieldValue, handleBlur, handleChange, touched } =
    formik

  return (
    <div
      className={classNames(
        'flex flex-col gap-6 pb-10 border-b border-divider-gray',
        className,
      )}
    >
      <HeaderSubheader
        title={`${typeTitle} Weight`}
        text={`Specify ${typeTitle} weight`}
      />

      <div className="col-span-full flex gap-4 items-center max-w-[500px]">
        <TextInput
          type="text"
          name="weight"
          placeholder={`${typeTitle} weight`}
          value={values.weight}
          onBlur={handleBlur}
          onChange={handleChange}
          errors={errors.weight && touched.weight ? errors.weight : ''}
          hasIcon={false}
          className=""
        />

        {values.weight && (
          <Dropdown
            loading={false}
            className=""
            menuClassName="!max-h-[200px]"
            menuButton={
              <TextInput
                type="text"
                name="weightUnit"
                placeholder="Weight unit"
                value={values.weightUnit}
                onBlur={handleBlur}
                onChange={handleChange}
                errors={
                  errors.weightUnit && touched.weightUnit
                    ? errors.weightUnit
                    : ''
                }
                hasIcon={false}
                readOnly
                extra={
                  <Icon
                    id={'left-caret'}
                    width={16}
                    height={16}
                    className="-rotate-90 text-sec-black"
                  />
                }
                className="!border-divider-gray"
              />
            }
            menuItems={productWeightOptions.map((opt) => ({
              ...opt,
              onClick: () => {
                setFieldValue('weightUnit', opt.value)
              },
            }))}
          />
        )}
      </div>
    </div>
  )
}
